import _each from "lodash/each";
import store from "~/js/store/store";
import { gsap, Quint, Circ, Cubic } from "gsap";
import Common from "~/js/common/common";
export default class Tooltip {
  constructor() {
    this.setup();
  }
  setup() {
    const tooltips = document.querySelectorAll(".js-tooltip");
    _each(tooltips, (elm, index) => {
      const text = elm.getAttribute("data-tooltip");
      if (text) {
        this.createTip(elm, text);
        elm.addEventListener("mouseover", (event) => {
          event.preventDefault();
          this.showTip(elm);
        });
        elm.addEventListener("mouseout", (event) => {
          event.preventDefault();
          this.hideTip(elm);
        });
      }
    });
  }
  createTip(elm, text) {
    let tip = document.createElement("div");
    tip.className = "jstooltip";
    tip.innerText = text;
    elm.appendChild(tip);
  }
  showTip(elm) {
    elm.classList.add("show");
  }
  hideTip(elm) {
    elm.classList.remove("show");
  }
}
